export default {
  methods: {
    // Will handle some boilerplate for submitting a form via ajax.
    // For example, it prevents default behavior of a submit button if bound via v-on:click or v-on:submit
    // It sets the loading state of the Vue app.
    // If a postFormContents method exists in the app, it calls it.
    ajaxFormSubmit(e) {
      if (e && typeof e.preventDefault !== 'undefined') {
        e.preventDefault();
      }
      if (typeof this.loading !== 'undefined') {
        this.loading = true;
      }
      if (typeof this.postFormContents !== 'undefined') {
        this.postFormContents();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/mixins/form.js